import { render } from "./cardFrame.vue?vue&type=template&id=30496cd1"
const script = {}

import "./cardFrame.vue?vue&type=style&index=0&id=30496cd1&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__